/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { SubjectiveSharebackResponseData } from "./SubjectiveSharebackResponseData";

/**
 * Subjective shareback plus a flag telling the client a fresher version is still generating.
 *
 * ``refreshing`` is True when the stored subjective was generated with age/sex that no longer
 * match the patient's profile and a regeneration is expected to replace it, so the shareback
 * UI should keep waiting instead of showing the stale ("adult patient") summary. See AI-1917.
 */
export interface SubjectiveSharebackResponse {
  id: string;
  user_id: string;
  conversation_id?: string | null;
  type: string;
  data: SubjectiveSharebackResponseData;
  source_conversation_ids?: string[] | null;
  patient_edited?: boolean;
  created_at: string;
  updated_at: string;
  refreshing?: boolean;
}
